/**
 * Shopper seed data - the single mock account used by the mock sign-in flow
 * (ACC-01). Default location anchors Local Finds distances to LA 90012.
 */
import { AlertChannel, NOTIFICATION_TOPICS } from '@core/models/shopper.enum';
import { ShopperState } from '@core/models/shopper.state';

export const seedShoppers = (): ShopperState[] => [
  {
    id: 1,
    displayName: 'Jess Alvarez',
    firstName: 'Jess',
    email: 'jess@email.com',
    phone: '(213) 555-0184',
    defaultLocation: { label: 'Los Angeles 90012', zip: '90012', lat: 34.0522, lng: -118.2437 },
    addresses: [
      {
        id: 1,
        label: 'Home',
        fullName: 'Jess Alvarez',
        addressLine: '350 S Grand Ave, Apt 12',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90012',
        phone: '(213) 555-0184',
        isDefault: true
      }
    ],
    notificationChannel: AlertChannel.EmailAndText,
    paymentMethods: [
      {
        id: 1,
        token: 'mock_pm_4242',
        brand: 'Visa',
        last4: '4242',
        expiry: '08 / 29',
        isDefault: true
      },
      {
        id: 2,
        token: 'mock_pm_8210',
        brand: 'Mastercard',
        last4: '8210',
        expiry: '11 / 27',
        isDefault: false
      }
    ],
    notificationTopics: [...NOTIFICATION_TOPICS]
  }
];
